import { FaCheck } from "react-icons/fa";

export const StepIndicator = ({ step, steps, formData }) => {
  const getStepSummary = () => {
    if (step === 1) {
      const validSlots = formData.preferredTimes.filter(
        (time) =>
          time.date &&
          time.start &&
          time.end &&
          new Date(`${time.date}T${time.start}`) > new Date()
      ).length;
      return `${validSlots}/${formData.preferredTimes.length} valid slots`;
    }
    if (step === 3) {
      return `${formData.selectedTutorIds.length}/3 selected`;
    }
    return "";
  };

  return (
    <div className="mb-2">
      <div className="flex justify-between text-sm text-text/60 mb-1">
        <span>
          Step {step} of {steps.length}
        </span>
        <span>{getStepSummary()}</span>
      </div>
      <div className="w-full bg-border rounded-full h-2">
        <div
          className="bg-primary h-2 rounded-full transition-all duration-300"
          style={{ width: `${(step / steps.length) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};
